import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/about/AboutPageClient.jsx");
